module.exports = __webpack_public_path__ + "static/media/CallingDirectory.c9a45dfe.svg";